"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserList$ = exports.removeUsers = exports.addUsers = exports.isUserBlocked = exports.BlackList$ = void 0;
var lodash_curry_1 = __importDefault(require("lodash.curry"));
var effector_1 = require("effector");
var QBAdapter_1 = require("../QBAdapter");
var users_1 = require("../users");
var findUsersByIds_1 = __importDefault(require("../users/findUsersByIds"));
var loadBlackList_1 = require("./loadBlackList");
exports.BlackList$ = effector_1.createStore({});
exports.isUserBlocked = function (userId) {
    var state = exports.BlackList$.getState();
    if (state[userId]) {
        return state[userId].blocked;
    }
    return false;
};
var handlerUpdate = lodash_curry_1.default(function (block, items) {
    var privacyListItems = items.map(function (item) {
        return {
            user_id: item.userId,
            action: block ? 'deny' : 'allow',
            mutualBlock: item.mutual,
        };
    });
    var privacyList = {
        name: QBAdapter_1.DEFAULT_BLACKLIST_NAME,
        items: privacyListItems,
    };
    return QBAdapter_1.updatePrivacyList(privacyList);
});
exports.addUsers = effector_1.createEffect().use(handlerUpdate(true));
exports.removeUsers = effector_1.createEffect().use(handlerUpdate(false));
var handleUpdateBlackList = lodash_curry_1.default(function (block, state, _a) {
    var params = _a.params;
    var newState = __assign({}, state);
    params.forEach(function (item) {
        newState[item.userId] = __assign(__assign({}, item), { blocked: block });
    });
    return newState;
});
exports.BlackList$.on(exports.addUsers.done, handleUpdateBlackList(true));
exports.BlackList$.on(exports.removeUsers.done, handleUpdateBlackList(false));
exports.BlackList$.on(loadBlackList_1.loadBlackList.done, function (state, _a) {
    var result = _a.result;
    if (!result) {
        return state;
    }
    return result.items.reduce(function (acc, item) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[item.user_id] = {
            userId: item.user_id,
            blocked: item.action === 'deny',
            mutual: item.mutualBlock,
        }, _a));
    }, {});
});
var ids = exports.BlackList$.updates.map(function (state) {
    return Object.keys(state).map(function (id) { return parseInt(id, 10); });
});
effector_1.forward({
    from: ids,
    to: findUsersByIds_1.default,
});
exports.UserList$ = effector_1.combine([exports.BlackList$, users_1.Users$], function (_a) {
    var blackList = _a[0], usersState = _a[1];
    var blockedList = Object.values(blackList).filter(function (item) { return item.blocked; });
    return blockedList.map(function (item) { return usersState[item.userId]; }).filter(Boolean);
});
//# sourceMappingURL=BlackList.js.map